export enum ACTION_TYPE {
  COPY = "content_copy",
  REMOVE = "do_not_disturb_on",
}

export enum BUTTON_SIZE {
  LARGE = "button-lg",
  SMALL = "button-sm",
}
